import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../../../kvComponent/core/assets";

import {IntermediatePart} from "../intermediatePart";
import {Shower} from "./shower";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'bathroom_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.floor";
    this.partThumbnail = floorThumbnail;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

}

class FloorBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathroom_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.floor";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FloorBody());
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize && layout.type !== 4) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Background.Floor;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}


